(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!customElements.get('cart-items')) {
    customElements.define(
      'cart-items',
      class CartItems extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.status = this.querySelector('[data-cart-status]');
          this.gateRequestSequence = 0;
          this.additionalOrderAllowed = false;
          this.addEventListener('change', (event) => {
            const input = event.target.closest('[data-line-key]');
            if (input) this.updateLine(input.dataset.lineKey, Number(input.value));
          });
          this.addEventListener('click', (event) => {
            const remove = event.target.closest('[data-line-remove]');
            if (remove) {
              event.preventDefault();
              this.updateLine(remove.dataset.lineRemove, 0);
            }
            const retry = event.target.closest('[data-additional-order-retry]');
            if (retry) {
              event.preventDefault();
              this.initAdditionalOrderGate();
            }
            const proceed = event.target.closest('[name="drg-proceed-to-delivery"]');
            if (proceed) {
              event.preventDefault();
              if (this.additionalOrderAllowed) window.location.assign(this.dataset.deliveryUrl);
            }
          });
          this.initAdditionalOrderGate();
        }

        disconnectedCallback() {
          this.gateRequestSequence += 1;
          this.gateController?.abort();
          this.setAdditionalOrderAllowed(false);
        }

        async updateLine(key, quantity) {
          this.setBusy(true);
          this.clearStatus();
          try {
            await this.invalidateAdditionalOrderProof();
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                id: key,
                quantity: quantity,
                sections: this.sectionId,
                sections_url: window.location.pathname,
              }),
            });
            const cart = await res.json().catch(() => null);
            if (!res.ok) {
              const message =
                cart && (cart.description || cart.message)
                  ? cart.description || cart.message
                  : this.dataset.cartDefaultError;
              await this.refreshCartSection(message);
              return;
            }
            if (window.setCartCount) window.setCartCount(cart.item_count);
            this.render(cart.sections && cart.sections[this.sectionId]);
          } catch (error) {
            await this.refreshCartSection(this.dataset.cartDefaultError);
          }
        }

        get gate() {
          return this.querySelector('[data-additional-order-gate]');
        }

        get gateMessage() {
          return this.querySelector('[data-additional-order-message]');
        }

        setAdditionalOrderAllowed(allowed) {
          this.additionalOrderAllowed = allowed;
          const proceed = this.querySelector('[name="drg-proceed-to-delivery"]');
          if (proceed) {
            proceed.disabled = !allowed;
            proceed.setAttribute('aria-disabled', allowed ? 'false' : 'true');
          }
        }

        setAcceleratedCheckoutBlocked(blocked) {
          document
            .querySelectorAll('shopify-accelerated-checkout, .additional-checkout-buttons, .shopify-payment-button')
            .forEach((element) => {
              element.toggleAttribute('data-drg-under-minimum-blocked', blocked);
              if (blocked) element.setAttribute('aria-hidden', 'true');
              else element.removeAttribute('aria-hidden');
            });
        }

        setGateMessage(message, state = 'neutral', retryable = false) {
          const success = state === 'success';
          const shortfall = this.querySelector('[data-additional-order-shortfall]');
          const successIcon = this.querySelector('[data-additional-order-success-icon]');
          if (shortfall) shortfall.hidden = success;
          if (successIcon) successIcon.hidden = !success;
          if (this.gate) this.gate.dataset.state = state;
          if (this.gateMessage) {
            this.gateMessage.textContent = message;
            this.gateMessage.dataset.state = state;
          }
          const retry = this.querySelector('[data-additional-order-retry]');
          if (retry) retry.hidden = !retryable;
          const login = this.querySelector('[data-additional-order-login]');
          if (login) login.hidden = state !== 'login';
        }

        clearGateOptions() {
          const fieldset = this.querySelector('[data-additional-order-options]');
          const list = this.querySelector('[data-additional-order-options-list]');
          if (fieldset) fieldset.hidden = true;
          if (list) list.replaceChildren();
        }

        async updateProofAttributes(context, expectedGeneration) {
          const helper = window.DRGAdditionalOrder;
          const write = async () => {
            if (expectedGeneration !== window.__drgAdditionalOrderGeneration) {
              throw new Error('stale proof write');
            }
            window.__drgProofWriteInProgress = true;
            try {
              const response = await fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ attributes: helper.proofAttributes(context) }),
              });
              if (!response.ok) throw new Error('proof attributes unavailable');
              return response.json();
            } finally {
              window.__drgProofWriteInProgress = false;
            }
          };
          const previous = window.__drgProofWriteQueue || Promise.resolve();
          const current = previous.then(write, write);
          window.__drgProofWriteQueue = current.catch(() => {});
          return current;
        }

        async invalidateAdditionalOrderProof() {
          this.gateRequestSequence += 1;
          this.gateController?.abort();
          window.__drgAdditionalOrderGeneration = (window.__drgAdditionalOrderGeneration || 0) + 1;
          this.gateGeneration = window.__drgAdditionalOrderGeneration;
          this.setAdditionalOrderAllowed(false);
          window.DRGAdditionalOrder.writeBrowserSession(window, null);
          await this.updateProofAttributes(null, this.gateGeneration);
        }

        formatDeliveryDate(value) {
          const parts = String(value).split('-').map(Number);
          if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) return value;
          return new Intl.DateTimeFormat('nl-NL', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
          }).format(new Date(parts[0], parts[1] - 1, parts[2]));
        }

        async selectAdditionalOrderOption(option, request, sequence) {
          if (sequence !== this.gateRequestSequence) return;
          this.setAdditionalOrderAllowed(false);
          this.setGateMessage(this.dataset.textSaving);
          const context = window.DRGAdditionalOrder.contextFromOption(option, request);
          try {
            await this.updateProofAttributes(context, this.gateGeneration);
            if (
              sequence !== this.gateRequestSequence ||
              this.gateGeneration !== window.__drgAdditionalOrderGeneration
            ) return;
            if (!window.DRGAdditionalOrder.writeBrowserSession(window, context)) {
              throw new Error('session storage unavailable');
            }
            this.setGateMessage(
              this.dataset.textSelected.replace('[date]', this.formatDeliveryDate(context.deliveryDate)),
              'success'
            );
            this.setAdditionalOrderAllowed(true);
          } catch (error) {
            if (sequence !== this.gateRequestSequence || this.gateGeneration !== window.__drgAdditionalOrderGeneration) return;
            window.DRGAdditionalOrder.writeBrowserSession(window, null);
            await this.updateProofAttributes(null, this.gateGeneration).catch(() => {});
            if (sequence !== this.gateRequestSequence || this.gateGeneration !== window.__drgAdditionalOrderGeneration) return;
            this.setGateMessage(this.dataset.textError, 'error', true);
          }
        }

        renderAdditionalOrderOptions(options, request, sequence) {
          this.clearGateOptions();
          const fieldset = this.querySelector('[data-additional-order-options]');
          const list = this.querySelector('[data-additional-order-options-list]');
          if (!fieldset || !list) return;
          options.forEach((option) => {
            const label = document.createElement('label');
            label.className = 'cart-minimum__option';
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = 'additional-order-delivery-stop';
            const body = document.createElement('span');
            const date = document.createElement('strong');
            date.textContent = this.formatDeliveryDate(option.deliveryDate);
            body.append(date);
            label.append(input, body);
            list.append(label);
            input.addEventListener('change', () => this.selectAdditionalOrderOption(option, request, sequence));
          });
          fieldset.hidden = false;
          this.setGateMessage(this.dataset.textChoose);
        }

        async requestAdditionalOrderOptions(request, sequence, invalidation) {
          if (sequence !== this.gateRequestSequence) return;
          this.gateController?.abort();
          this.gateController = new AbortController();
          this.setGateMessage(this.dataset.textChecking);
          try {
            // The proxy only reads eligibility; it does not use cart proof
            // attributes. Start it alongside the clear, but await both before
            // saving a new proof or rendering a result.
            const [{ response, payload }] = await Promise.all([window.DRGAdditionalOrder.fetchJSONWithRetry(this.dataset.proxyPath, {
              method: 'POST',
              credentials: 'same-origin',
              cache: 'no-store',
              signal: this.gateController.signal,
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                cart_amount_minor: request.cartAmountMinor,
                currency: request.currency,
                cart_nonce: request.nonce,
              }),
            }), invalidation]);
            if (!payload?.data || typeof payload.data.eligible !== 'boolean') throw new Error('invalid eligibility response');
            const result = window.DRGAdditionalOrder.normalizeResponse(payload);
            if (sequence !== this.gateRequestSequence) return;
            if (!response.ok || !result.eligible) {
              const loginRequired = result.reasonCode === 'customer_login_required';
              const noEligibleOrder = response.ok && result.reasonCode === 'additional_order_not_verified';
              const retryable = !loginRequired && !noEligibleOrder;
              this.setGateMessage(
                loginRequired
                  ? this.dataset.textLogin
                  : retryable
                    ? this.dataset.textError
                    : this.dataset.textNotVerified,
                loginRequired ? 'login' : noEligibleOrder ? 'shortfall' : 'error',
                retryable
              );
              return;
            }
            if (result.options.length === 1) {
              await this.selectAdditionalOrderOption(result.options[0], request, sequence);
            } else {
              this.renderAdditionalOrderOptions(result.options, request, sequence);
            }
          } catch (error) {
            if (sequence === this.gateRequestSequence) {
              this.gateController?.abort();
              this.setGateMessage(this.dataset.textError, 'error', true);
            }
          }
        }

        async initAdditionalOrderGate() {
          const helper = window.DRGAdditionalOrder;
          if (!helper) {
            document.addEventListener('drg:additional-order-helper-ready', () => this.initAdditionalOrderGate(), { once: true });
            return;
          }
          if (!this.gate) return;
          this.clearGateOptions();
          this.setAdditionalOrderAllowed(false);
          this.setAcceleratedCheckoutBlocked(this.dataset.cartBelowMinimum === 'true');
          const invalidation = this.invalidateAdditionalOrderProof();
          const sequence = this.gateRequestSequence;
          if (this.dataset.cartBelowMinimum === 'true' && this.dataset.customerAuthenticated === 'true') {
            const request = {
              cartAmountMinor: Number(this.dataset.cartAmountMinor),
              currency: this.dataset.cartCurrency || 'EUR',
              nonce: helper.createNonce(window.crypto),
            };
            await this.requestAdditionalOrderOptions(request, sequence, invalidation);
            return;
          }
          try {
            await invalidation;
          } catch (error) {
            if (sequence === this.gateRequestSequence) this.setGateMessage(this.dataset.textError, 'error', true);
            return;
          }
          if (sequence !== this.gateRequestSequence) return;
          if (this.dataset.cartBelowMinimum === 'true') {
            this.setGateMessage(this.dataset.textLogin, 'login');
          }
        }

        async refreshCartSection(message) {
          try {
            const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) =>
              r.json()
            );
            if (window.setCartCount) window.setCartCount(cart.item_count);

            const sectionUrl = `${window.location.pathname}?section_id=${encodeURIComponent(
              this.sectionId
            )}`;
            const sectionHtml = await fetch(sectionUrl, { headers: { Accept: 'text/html' } }).then((r) =>
              r.ok ? r.text() : ''
            );
            if (sectionHtml) {
              this.render(sectionHtml, message);
              return;
            }
            this.restoreQuantities(cart);
            this.showStatus(message);
          } catch (error) {
            this.showStatus(message);
          } finally {
            this.setBusy(false);
          }
        }

        restoreQuantities(cart) {
          if (!cart || !Array.isArray(cart.items)) return;
          const quantities = new Map(cart.items.map((item) => [item.key, item.quantity]));
          this.querySelectorAll('[data-line-key]').forEach((input) => {
            const key = input.dataset.lineKey;
            if (!quantities.has(key)) {
              window.location.reload();
              return;
            }
            input.value = quantities.get(key);
            input.defaultValue = quantities.get(key);
          });
        }

        render(html, message) {
          if (!html) {
            window.location.reload();
            return;
          }
          const fresh = new DOMParser().parseFromString(html, 'text/html');
          const next = fresh.querySelector('cart-items');
          if (next) {
            if (message) {
              const status = next.querySelector('[data-cart-status]');
              if (status) {
                status.textContent = message;
                status.hidden = false;
              }
            }
            // Swap in the freshly rendered element; its connectedCallback rebinds listeners.
            this.replaceWith(next);
          } else {
            window.location.reload();
          }
        }

        showStatus(message) {
          if (!this.status || !message) return;
          this.status.textContent = message;
          this.status.hidden = false;
        }

        clearStatus() {
          if (!this.status) return;
          this.status.textContent = '';
          this.status.hidden = true;
        }

        setBusy(busy) {
          this.toggleAttribute('aria-busy', busy);
          this.style.opacity = busy ? '0.6' : '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-sections"] && !Shopify.designMode) return;
  try {
    
  // The browser applies the #anchor jump before the product images above the
  // target have their final height, so it can land short of the section. Redo
  // the jump once the page has settled, and on every hash change (the menu
  // links to the same page, so those are hash changes, not page loads).
  (function () {
    var userScrolled = false;

    function jumpToHash() {
      if (!window.location.hash) return;
      var target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      if (target && target.classList.contains('category-sections__group')) {
        target.scrollIntoView();
      }
    }

    ['wheel', 'touchmove', 'keydown'].forEach(function (event) {
      window.addEventListener(event, function () { userScrolled = true; }, { passive: true, once: true });
    });

    window.addEventListener('load', function () {
      if (!userScrolled) jumpToHash();
    });

    window.addEventListener('hashchange', function () {
      userScrolled = false;
      jumpToHash();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('menu-drawer.header').forEach((header) => {
    const section = header.closest('.shopify-section');
    if (!section) return;

    section.classList.add('header-section--sticky');

    let previousScrollY = Math.max(window.scrollY, 0);
    let frameRequested = false;

    const showHeader = () => section.classList.remove('header-section--hidden');

    const updateHeader = () => {
      const currentScrollY = Math.max(window.scrollY, 0);
      const overlayOpen = header.querySelector('#menu-drawer[open], .header__search[open]');

      if (overlayOpen || currentScrollY <= header.offsetHeight) {
        showHeader();
      } else if (currentScrollY > previousScrollY) {
        section.classList.add('header-section--hidden');
      } else if (currentScrollY < previousScrollY) {
        showHeader();
      }

      previousScrollY = currentScrollY;
      frameRequested = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(updateHeader);
      },
      { passive: true }
    );

    header.addEventListener('toggle', showHeader, true);
    header.addEventListener('close', showHeader, true);
  });

  // Enhancement only — the <details>/<summary> already opens/closes with zero
  // JS. This just adds the niceties <details> doesn't support natively:
  // auto-focus the input on open, and close on outside-click or Escape.
  document.querySelectorAll('.header__search').forEach((details) => {
    const input = details.querySelector('.header__search-input');

    details.addEventListener('toggle', () => {
      if (details.open && input) input.focus();
    });

    document.addEventListener('click', (event) => {
      if (details.open && !details.contains(event.target)) details.open = false;
    });

    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) {
        details.open = false;
        details.querySelector('summary').focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  document.querySelectorAll('[data-confirm-delete]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (!window.confirm(form.dataset.confirmMessage || 'Verwijderen?')) {
        event.preventDefault();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          if (!entries[0].isIntersecting) return;
          obs.unobserve(this);
          this.loadRecommendations();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      observer.observe(this);
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const parsed = document.createElement('div');
          parsed.innerHTML = text;
          const rendered = parsed.querySelector('product-recommendations');
          if (rendered && rendered.innerHTML.trim().length) {
            this.innerHTML = rendered.innerHTML;
          }
        })
        .catch((error) => {
          console.error('Product recommendations failed to load', error);
        });
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
